export default __webpack_public_path__ + "static/media/SalesReport.7f1a9ff3.jpg";